import axios from 'axios';
import {createAuth} from "../Helpers";
import {Team} from "../domain/Team";
import {Reducer} from "redux";
import {apiRootUrl, ReducerMethods, TA} from "./configureStore";

export const reducerName = 'teamState';

const TEAM_GETALL_REQUEST = 'TEAM_GETALL_REQUEST';
const TEAM_GETALL_RESPONSE = 'TEAM_GETALL_RESPONSE';

export interface TeamState {
    teams: Team[],
    loading: {
        getAll?: boolean
    }
}

const initialState = {
    teams: [],
    loading: {
        getAll: false
    }
};

export const actionCreators = {
    getAll: (): TA => async(dispatch, getState) => {
        dispatch({type: TEAM_GETALL_REQUEST});

        axios({
            method: 'GET',
            url:`${apiRootUrl}/api/team`,
            withCredentials: true,
            auth: createAuth(getState)
        }).then((response) => {
            const data = response.data;
            dispatch({type: TEAM_GETALL_RESPONSE, data: data});
        }).catch((data) =>{
            console.log('ERROR FETCHING TEAMS', data);
        });
    }
};

const reducerMethods: ReducerMethods<TeamState> = {
    TEAM_GETALL_REQUEST: (state, action) => {
        return {
            ...state,
            loading: {
                ...state.loading,
                getAll: true
            }
        }
    },
    TEAM_GETALL_RESPONSE: (state, action) => {
        return{
            ...state,
            teams: action.data,
            loading: {
                ...state.loading,
                getAll: false,
            }
        }
    }
};

export const reducer: Reducer<TeamState, any> = (state, action) => {
    state = state || initialState;
    const method = reducerMethods[action.type];
    if (method) return method(state, action);
    return state;
};
